export default "__VITE_ASSET__CoRO23nQ__"